// Common
import RouterFrame from '../../../components/share/RouterFrame.vue'
// Bundles: Internal/Gen
import IntgenPersonTaskListing from '../../../components/bundles/share/tasksListing/Listing.vue'

const workflowName = 'main_person'
const routePrefix = `intgen_${workflowName}`

export default {
  path: 'generalicrls-osoba',
  component: RouterFrame,
  meta: {
    title: 'Generali CRLS - osoba',
    icon: 'generali',
    menuLink: true,
    meta: {
      acl: {
        service: 'intgen',
        action: 'get_main_person_tasks'
      }
    }
  },
  children: [
    {
      path: '',
      component: IntgenPersonTaskListing,
      name: `${routePrefix}_task_listing`,
      meta: {
        title: 'Lista zleceń - osoba',
        acl: {
          service: 'intgen',
          action: 'get_main_person_tasks'
        }
      }
    }
  ]
}
